import axios from "axios";
import axiosRetry from "axios-retry";
import { codeBundleId } from "@lib/sentry";
import * as Sentry from "@sentry/react-native";
import { baseURL, appVersion, appVersionCode } from "../config";
import {
  onFulfilledRequestInterceptor,
  onFulfilledResponseInterceptor,
  onRejectedResponseInterceptor,
} from "./api-utils";

const cmsV2Api = axios.create({
  baseURL: `${baseURL}cms-v2`,
  timeout: 10000,
  headers: {
    "x-app-name": "CL",
    "x-app-version": appVersion,
    "x-app-version-cp": codeBundleId,
    "x-app-version-code": appVersionCode,
    "use-applinks-cl": "true",
  },
});

axiosRetry(cmsV2Api, { retryDelay: axiosRetry.exponentialDelay, retries: 3 });

cmsV2Api.interceptors.request.use(onFulfilledRequestInterceptor);

cmsV2Api.interceptors.response.use(
  onFulfilledResponseInterceptor,
  onRejectedResponseInterceptor,
);

export const getHomePageNew = ({ limit = 10, offset = 0 }) =>
  cmsV2Api.post(`v1/home`, {
    limit,
    offset,
  });

export const getCMSEntityById = ({ id, limit = 50, offset }) => {
  const data = {
    id,
    limit,
    offset,
    isRoot: false,
  };
  return cmsV2Api
    .post("/v1/item", data)
    .then((response) => {
      return response.data;
    })
    .catch((e) => {
      Sentry.captureException(e);
    });
};

export { cmsV2Api };
